import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();
  const [requestedLocation, setRequestedLocation] = useState(null);

  useEffect(() => {
    if (localStorage.getItem('preLogoutPath')) {

      setRequestedLocation(localStorage.getItem('preLogoutPath'))
      localStorage.removeItem('preLogoutPath');

    } else {
      setRequestedLocation(PATH_DASHBOARD.general.home)
    }
  }, []);

  if (isAuthenticated) {
    localStorage.removeItem('sessionExpired');
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
